var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyListBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "companies_desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 898.41,
    height: 603.339,
    viewBox: "0 0 898.41 603.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 450.806,
    height: 2,
    transform: "translate(52.83 11.422)",
    fill: "#cbcbcb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 2,
    height: 63.564,
    transform: "translate(441.229 12.176)",
    fill: "#cbcbcb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M612.156,126.123H715.205V12.113h-2v112.01H612.156Z",
    transform: "translate(-334.951)",
    fill: "#cbcbcb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 2,
    height: 63.564,
    transform: "translate(310.525 12.176)",
    fill: "#cbcbcb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 2,
    height: 63.564,
    transform: "translate(276.967 125.176)",
    fill: "#cbcbcb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 2,
    height: 63.564,
    transform: "translate(173.409 12.176)",
    fill: "#cbcbcb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 2,
    height: 63.564,
    transform: "translate(104.852 12.176)",
    fill: "#cbcbcb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 37.978,
    height: 14.797,
    transform: "translate(423 85.461)",
    fill: "#ffc000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 37.978,
    height: 14.797,
    transform: "translate(293 85.461)",
    fill: "#1a536e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 37.978,
    height: 14.797,
    transform: "translate(155 85.461)",
    fill: "#cbcbcb"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 37.978,
    height: 14.797,
    transform: "translate(89 85.461)",
    fill: "#ffc000"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 37.978,
    height: 14.797,
    transform: "translate(0 5.461)",
    fill: "#1a536e"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 37.978,
    height: 14.797,
    transform: "translate(259 197.463)",
    fill: "#1a536e"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 60.882,
    height: 23.72,
    transform: "translate(516.549)",
    fill: "#ffc000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M337.259,241.153l-3.977,35.877-50.8.875,6.131-42.918Z",
    transform: "translate(278.67 84.605)",
    fill: "#ffb7b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M350.666,511.473a8.213,8.213,0,0,1,2.229-12.4l-2.358-18.62,10.966-4.193,2.961,26.342a8.258,8.258,0,0,1-13.8,8.866Z",
    transform: "translate(288.151 -105.918)",
    fill: "#ffb7b7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M367.821,507.436H357.082l-5.108-41.419h15.849Z",
    transform: "translate(178.613 84.605)",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M487.657,694.454H466.509a13.477,13.477,0,0,0-13.477,13.476v.439h34.624Z",
    transform: "translate(61.516 -105.918)",
    fill: "#003050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M245.2,507.436H234.459l-5.108-41.419H245.2Z",
    transform: "translate(423.86 84.605)",
    fill: "#ffb7b7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M365.033,694.454H343.885a13.477,13.477,0,0,0-13.477,13.476v.439h34.624Z",
    transform: "translate(306.764 -105.918)",
    fill: "#003050"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M386.276,496.935,381.553,442.3l-13.779-49.9A18.848,18.848,0,0,0,351.5,378.733l-.45-.043-2.448,37.454,17.62,36.206,5.824,43.437Z",
    transform: "translate(267.324 -105.918)",
    fill: "#003f5e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M414.964,446.677,422.2,459.7s28.209,28.517,30.379,72.571l26.188,149.939-24.271-.6L405.352,541.077,370.594,600.7l-17.379,77.906-27.567-5.094,12.285-90.491,23.672-84.2,2.4-45.845Z",
    transform: "translate(197.793 -105.918)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 21.513,
    cy: 21.513,
    r: 21.513,
    transform: "translate(566.179 211.67)",
    fill: "#ffb7b7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M417.55,387.962c-4-7.807-5.361-16.672-8.437-24.885s-8.665-16.362-17.138-18.626c-4.806-1.284-9.914-.5-14.851-1.111-4.341-.537-9.015-2.754-10.677-6.609a27.228,27.228,0,0,0-1.4-11.3c-3.1-8.8-10.482-15.745-19.091-19.336-6.993-2.917-15.047-3.741-22.189-1.208s-13.137,8.724-14.42,16.192,2.833,15.807,9.931,18.46c5.1,1.9,11.659,1.27,14.987,5.575,3.371,4.36.955,10.715-2.107,15.3l.209.213c10,.117,20.81-1.815,27.7-9.066a21.941,21.941,0,0,0,2.058-2.532c.211.338.432.669.67.984,3.468,4.606,8.9,7.219,14.072,9.764s10.539,5.4,13.646,10.259c5.615,8.777,1.929,20.6,5.14,30.51a22.538,22.538,0,0,0,42.388,1.375C429.3,402.651,421.547,395.769,417.55,387.962Z",
    transform: "translate(255.057 -105.918)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M441.651,510.759a8.213,8.213,0,0,1,7.709-9.959l6.522-17.6,11.661,1.355-9.559,24.724a8.258,8.258,0,0,1-16.333,1.479Z",
    transform: "translate(93.2 -105.918)",
    fill: "#ffb7b7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M436.5,451.972l6.225-29.949,1.956-22.813a53.714,53.714,0,0,0-10.18-36.318l-1.99-2.718-33.5,11.908-16.334,21.532c-9.968,10.022-2.164,19.617-1.076,20.853l.334,30.263.376.05Z",
    transform: "translate(179.66 -105.918)",
    fill: "#ffc000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M431.541,504.49l24.916-57.412,3.62-52.6.73-11.055a10.566,10.566,0,0,0-21.016-2.1l-7.843,58.636-13.5,58.5Z",
    transform: "translate(122.927 -105.918)",
    fill: "#003f5e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M104.795,709.257h537a1,1,0,0,0,0-2h-537a1,1,0,0,0,0,2Z",
    transform: "translate(255.615 -105.918)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyListBg);
export default __webpack_public_path__ + "static/media/company-list-bg.a1863c2fd34f4a66d448544758ed0550.svg";
export { ForwardRef as ReactComponent };